export const once = <Fn extends (...args: any[]) => any>(
  fn: Fn,
): ((...args: Parameters<Fn>) => ReturnType<typeof fn>) => {
  let res: ReturnType<typeof fn>
  return (...args: Parameters<Fn>) => {
    if (res) {
      return res
    }
    res = fn(...args)
    return res
  }
}
